/* ==========================================================================
   Paris Gambit — Floating Cart
   - Un seul fetch /cart.js au chargement
   - Mises à jour via interception ciblée des routes /cart/*
   - Injection DOM : desktop au-dessus des catégories, mobile à côté du
     sélecteur de catégorie (sur la page collection).
   ========================================================================== */

(function () {
  'use strict';

  const IDS = {
    desktop: 'pg-floating-cart-desktop',
    mobile: 'pg-floating-cart-mobile',
    count: 'pg-floating-cart-count',
    total: 'pg-floating-cart-total',
    countMobile: 'pg-floating-cart-count-mobile',
  };

  const CART_ENDPOINTS = ['/cart/add', '/cart/change', '/cart/update', '/cart/clear'];

  function formatPrice(cents) {
    return (cents / 100).toFixed(2) + '€';
  }

  function setVisible(el, visible) {
    if (el) el.dataset.visible = visible ? 'true' : 'false';
  }

  function render(cart) {
    const desktop = document.getElementById(IDS.desktop);
    const mobile = document.getElementById(IDS.mobile);

    if (!cart || cart.item_count === 0) {
      setVisible(desktop, false);
      setVisible(mobile, false);
      return;
    }

    const countEl = document.getElementById(IDS.count);
    const totalEl = document.getElementById(IDS.total);
    const countMobileEl = document.getElementById(IDS.countMobile);

    if (countEl) {
      countEl.textContent = cart.item_count;
    }
    // " item"/" items" lives in a separate span so the compact cart can show
    // just the number (the unit span is hidden via CSS there).
    const unitEl = document.querySelector('#' + IDS.desktop + ' .pg-cart-count-unit');
    if (unitEl) {
      unitEl.textContent = cart.item_count > 1 ? ' items' : ' item';
    }
    if (totalEl) {
      totalEl.textContent = formatPrice(cart.total_price);
    }
    if (countMobileEl) {
      countMobileEl.textContent = String(cart.item_count);
    }

    setVisible(desktop, true);
    setVisible(mobile, true);
  }

  function refresh() {
    return fetch('/cart.js', { cache: 'no-store' })
      .then((res) => res.json())
      .then(render)
      .catch(() => {});
  }

  function isCartMutationUrl(url) {
    if (!url) return false;
    const path = typeof url === 'string' ? url : url.url || '';
    return CART_ENDPOINTS.some((endpoint) => path.indexOf(endpoint) !== -1);
  }

  // Intercept ciblé de fetch uniquement pour les routes cart.
  const originalFetch = window.fetch;
  window.fetch = function (input, init) {
    const result = originalFetch.apply(this, arguments);
    if (isCartMutationUrl(input)) {
      result.then(() => refresh()).catch(() => {});
    }
    return result;
  };

  // Placement DOM sur la page collection
  function relocate() {
    const desktop = document.getElementById(IDS.desktop);
    const mobile = document.getElementById(IDS.mobile);

    // --- Desktop : dans .pg-sidebar (au-dessus de .pg-category-list si présent) ---
    if (desktop) {
      const sidebar = document.querySelector('.pg-sidebar');
      if (sidebar && desktop.parentNode !== sidebar) {
        const categoryList = sidebar.querySelector('.pg-category-list');
        if (categoryList) {
          sidebar.insertBefore(desktop, categoryList);
        } else {
          sidebar.appendChild(desktop);
        }
      }
    }

    // --- Mobile : la cible normale est .pg-mobile-header (le snippet est
    //     déjà rendu dedans côté serveur). On ajoute la classe d'hôte pour
    //     que le CSS prenne effet, et on relocate seulement si l'élément est
    //     ailleurs (page sans header → fallback .pg-mobile-menu-wrapper). ---
    if (mobile) {
      const header = document.querySelector('.pg-mobile-header');
      const fallback = document.querySelector('.pg-mobile-menu-wrapper');
      const mobileTarget = header || fallback;
      if (mobileTarget) {
        mobileTarget.classList.add('pg-cart-mobile-host');
        if (mobile.parentNode !== mobileTarget) {
          mobileTarget.appendChild(mobile);
        }
      }
    }
  }

  function boot() {
    relocate();
    refresh();
  }

  // Section reload depuis le theme editor
  document.addEventListener('shopify:section:load', function () {
    relocate();
    refresh();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
